import axios from 'axios'
import router from "@/router";
import {getValidUser, getAdminName, logoutAndRedirect, createAuthExpiredError} from "@/utils/auth";

const request = axios.create({
    baseURL: process.env.VUE_APP_BASE_URL,
    timeout: 30000
})

request.interceptors.request.use(config => {
    const user = getValidUser()
    const isLoginApi = config.url && config.url.includes('/administrate/signIn')
    if (!user && !isLoginApi) {
        logoutAndRedirect(router)
        return Promise.reject(createAuthExpiredError())
    }
    const adminName = getAdminName(user)
    if (adminName) {
        config.headers['X-Admin-Name'] = adminName
    }
    return config
}, error => {
    return Promise.reject(error)
});

request.interceptors.response.use(
    response => {
        let res = response.data;
        if (response.config.responseType === 'blob') {
            return res
        }
        if (typeof res === 'string') {
            res = res ? JSON.parse(res) : res
        }
        if (res.code === '401' || res.code === 401) {
            logoutAndRedirect(router)
            return Promise.reject(createAuthExpiredError())
        }
        return res;
    },
    error => {
        if (error && error.response && error.response.status === 401) {
            logoutAndRedirect(router)
            return Promise.reject(createAuthExpiredError())
        }
        console.log('err' + error)
        return Promise.reject(error)
    }
)

export default request
